import frappe from './frappe';
import { getCustomerByEmail } from './login';
import { createShoppingCart } from './posOrders';

// Registra un nuevo usuario como Customer en Frappe (o completa un Customer
// invitado ya existente creado por el checkout de kits sin contraseña).
export async function registrarUsuario(userData) {
    try {
        const existente = await getCustomerByEmail(userData.email);

        if (existente && existente.custom_password_hash) {
            // Ya existe una cuenta con este correo
            return false;
        }

        let customer;
        if (existente) {
            // Cliente invitado existente (sin contraseña) -> completar la cuenta
            const { data } = await frappe.put(`/api/resource/Customer/${existente.name}`, {
                customer_name: userData.name,
                mobile_no: userData.phone,
                custom_password_hash: userData.idprof1,
            });
            customer = data.data;
        } else {
            const { data } = await frappe.post('/api/resource/Customer', {
                customer_name: userData.name,
                customer_type: 'Individual',
                email_id: userData.email,
                mobile_no: userData.phone,
                custom_password_hash: userData.idprof1,
            });
            customer = data.data;
        }

        await createShoppingCart(customer.name);
        return customer;
    } catch (error) {
        console.error('Error al registrar usuario:', error.response?.data || error.message);
        throw error;
    }
}

export async function updateUserData({ id, name, phone, email, address }) {
    try {
        const { data } = await frappe.put(`/api/resource/Customer/${id}`, {
            customer_name: name,
            mobile_no: phone,
            email_id: email,
            custom_direccion: address,
        });
        return data.data;
    } catch (error) {
        console.error("Error actualizando usuario:", error.response?.data || error.message);
        throw error;
    }
}
